import { render, staticRenderFns } from "./PraticaAutotrasportoDettagli.vue?vue&type=template&id=6173bf96&"
import script from "./PraticaAutotrasportoDettagli.vue?vue&type=script&lang=js&"
export * from "./PraticaAutotrasportoDettagli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6173bf96')) {
      api.createRecord('6173bf96', component.options)
    } else {
      api.reload('6173bf96', component.options)
    }
    module.hot.accept("./PraticaAutotrasportoDettagli.vue?vue&type=template&id=6173bf96&", function () {
      api.rerender('6173bf96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/PraticaAutotrasportoDettagli.vue"
export default component.exports